var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22,
    stroke: "#2351DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 13.75H15.2109C14.5469 13.75 14 14.3359 14 15.0391V30C14 30.7031 14.5469 31.25 15.2109 31.25H30.25C30.9141 31.25 31.5 30.7031 31.5 30V15.0391C31.5 14.3359 30.9141 13.75 30.25 13.75ZM19.2734 28.75H16.6953V20.4297H19.2734V28.75ZM17.9844 19.2578C17.125 19.2578 16.4609 18.5938 16.4609 17.7734C16.4609 16.9531 17.125 16.25 17.9844 16.25C18.8047 16.25 19.4688 16.9531 19.4688 17.7734C19.4688 18.5938 18.8047 19.2578 17.9844 19.2578ZM29 28.75H26.3828V24.6875C26.3828 23.75 26.3828 22.5 25.0547 22.5C23.6875 22.5 23.4922 23.5547 23.4922 24.6484V28.75H20.9141V20.4297H23.375V21.5625H23.4141C23.7656 20.8984 24.625 20.1953 25.875 20.1953C28.4922 20.1953 29 21.9531 29 24.1797V28.75Z",
    fill: "#2351DC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.9eafbd429f942074a6c3d1c052233eb7.svg";
export { ForwardRef as ReactComponent };